"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _UnauthorizedError = require("./UnauthorizedError");
Object.keys(_UnauthorizedError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UnauthorizedError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UnauthorizedError[key];
    }
  });
});